import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

import { IconComponent } from "./types";

export const PlusIcon: IconComponent = (props) => {
  return <FontAwesomeIcon {...props} icon={faPlus} color="#5a5c60" />;
};
